// Rotates through its direct children, one at a time, cross-fading between them.
// Each child is a trust-badge row (icon + text) rendered by the _trust-badge-row block.
class TrustBadgeRotator extends HTMLElement {
  /** @type {Element[]} */
  items = [];

  /** @type {number} */
  index = 0;

  /** @type {ReturnType<typeof setInterval> | undefined} */
  timer;

  #controller = new AbortController();

  connectedCallback() {
    this.items = Array.from(this.children);

    if (this.items.length === 0) return;

    this.items[0].classList.add('is-active');

    if (this.items.length < 2) return;

    if (this.dataset.pauseOnHover === 'true') {
      const { signal } = this.#controller;

      this.addEventListener('mouseenter', () => this.#pause(), { signal });
      this.addEventListener('mouseleave', () => this.#resume(), { signal });
      this.addEventListener('focusin', () => this.#pause(), { signal });
      this.addEventListener('focusout', () => this.#resume(), { signal });
    }

    this.#resume();
  }

  disconnectedCallback() {
    this.#pause();
    this.#controller.abort();
  }

  #pause() {
    clearInterval(this.timer);
  }

  #resume() {
    clearInterval(this.timer);
    const interval = parseInt(this.dataset.interval ?? '', 10) || 4000;
    this.timer = setInterval(() => this.#next(), interval);
  }

  #next() {
    this.items[this.index]?.classList.remove('is-active');
    this.index = (this.index + 1) % this.items.length;
    this.items[this.index]?.classList.add('is-active');
  }
}

if (!customElements.get('trust-badge-rotator')) {
  customElements.define('trust-badge-rotator', TrustBadgeRotator);
}
